import {
  BatchSchoolStatisticsConditionListItem,
  BatchSchoolStatisticsConditionListItemFromJSON
} from '@/api/models/batch/BatchSchoolStatisticsConditionListItem'

export interface BatchSchoolStatisticsPageLoadResult {
  items: BatchSchoolStatisticsConditionListItem
}

export function BatchSchoolStatisticsPageLoadResultFromJSON(
  json: any
): BatchSchoolStatisticsPageLoadResult {
  return {
    items: BatchSchoolStatisticsConditionListItemFromJSON(json)
  }
}
